var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.params.mallId)?_c('notice-box',{attrs:{"notice-list":_vm.noticeList,"is-alert":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }